import { render, staticRenderFns } from "./TopSwitch.vue?vue&type=template&id=3805a944&scoped=true"
import script from "./TopSwitch.vue?vue&type=script&lang=js"
export * from "./TopSwitch.vue?vue&type=script&lang=js"
import style0 from "./TopSwitch.vue?vue&type=style&index=0&id=3805a944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3805a944",
  null
  
)

export default component.exports